import _default from './Input';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Input/index.js
// module id = 707
// module chunks = 0